import React from 'react';

const SidebarSearch = ({ value, onChange, onClear, isPending }) => (
  <div className="sidebar-search">
    <div className="sidebar-search-box">
      <i className="fas fa-search" aria-hidden="true" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Menüde ara…"
        aria-label="Menüde ara"
        autoComplete="off"
        spellCheck={false}
      />
      {value ? (
        <button
          type="button"
          className="search-clear-btn"
          onClick={onClear}
          aria-label="Aramayı temizle"
        >
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      ) : null}
    </div>
    {isPending ? (
      <span className="sidebar-search-pending" aria-live="polite">
        Aranıyor…
      </span>
    ) : null}
  </div>
);

export default SidebarSearch;
